export default "__VITE_ASSET__DDvIaPdw__"